import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ImpressumPage = () => {
  const { t } = useTranslation("platformPages");

  useEffect(()=>{
      document.title = t('impressum.name')
  },[]);
  return (
    <div className='container-fluid py-4 overflow-auto'>
      <h1>{t('impressum.name')}</h1>
      <p>
        <strong>{t('impressum.p1')}</strong><br />
        {t('impressum.company')} <br />
        {t('impressum.street')} <br />
        {t('impressum.city')}
      </p>
      <p>
        <strong>{t('impressum.represented')}</strong> <br />
        {t('impressum.owner')}  Tobias Strauß
      </p>
      <p>
        <strong>{t('impressum.contact')}</strong> <br />
        {t('impressum.telephone')} 0176 34155774 <br />
        {t('impressum.eMail')} contact(at)sengilabs.ai <br/>
        {t('impressum.ustId')} DE313532897
      </p>
      <p>
        <strong>{t('impressum.registration.name')}</strong> <br />
        {t('impressum.registration.l1')}<br />
        {t('impressum.registration.l2')}<br/>
        {t('impressum.registration.l3')} HRB-24526
      </p>
      <p>
        <strong>{t('impressum.p2.name')}</strong> <br />
        {t('impressum.company')} {t('impressum.represented')}<br />
        {t('impressum.owner')} Tobias Strauß <br/>
        {t('impressum.street')} <br />
        {t('impressum.city')} <br/> <br/>
        {t('impressum.p2.l1')} <br/>
        {t('impressum.p2.l2')} <br/>
        {t('impressum.p2.l3')} <br/>

      </p>

      <p>
        <strong>{t('impressum.p3.name')}</strong> <br />
        {t('impressum.p3.l1')} <br/> <br/>
        {t('impressum.p3.l2')} 
      </p>
      <p>
        <strong>{t('impressum.p4.name')}</strong> <br />
        {t('impressum.p4.l1')} <br/> <br/>
        {t('impressum.p4.l2')}
      </p>
      <p>
        <strong>{t('impressum.p5.name')}</strong> <br />
        {t('impressum.p5.l1')} <br/> <br/>
        {t('impressum.p5.l2')} <br/> <br/>
        {t('impressum.source')} https://www.e-recht24.de/impressum-generator.html
      </p>
      <p>
        <strong>{t('impressum.p6.name')}</strong> <br/>
        {t('impressum.p6.l1')}
      </p>
    </div>
  );
};

export default ImpressumPage;
